/**
 * Upcoming Sessions
 */
 const UpcomingSessions = [
  {
      image: "assets/images/users/avatar-1.jpg",
      name: 'Alex Angotti',
      date: 'Wednesday, July 24',
      time: '11:00 AM',
      type: 'Private (60 min)',
      status: 'Scheduled'
  },
  {
      image: "assets/images/users/avatar-2.jpg",
      name: 'Bob Buttons',
      date: 'Wednesday, July 25',
      time: '7:00 AM',
      type: 'Private (60 min)',
      status: 'Scheduled'
  },
  {
      image: "assets/images/users/avatar-3.jpg",
      name: 'Dave Dawson',
      date: 'Wednesday, July 26',
      time: '4:00 PM',
      type: 'Private (60 min)',
      status: 'Scheduled'
  },
];

/**
 * Past Sessions
 */
 const PastSessions = [
  {
      image: "assets/images/users/avatar-4.jpg",
      name: 'Ernie Eagle',
      date: 'Wednesday, July 14',
      time: '11:00 AM',
      type: 'Private (60 min)',
      status: 'Scheduled'
  },
  {
      image: "assets/images/users/avatar-5.jpg",
      name: 'Fred Furguson',
      date: 'Wednesday, July 15',
      time: '7:00 AM',
      type: 'Private (60 min)',
      status: 'Scheduled'
  },
];

/**
 * Stat Counder Data
 */
const statData = [{
    title: 'COMPLETED SESSIONS',
    value: 0,
    icon: 'bx-dumbbell',
    //   icon: 'bx-dollar-circle',
    percentage: '0.00',
    //   profit: 'up'
    profit: 'equal'
}, {
    title: 'ACTIVE CLIENTS',
    value: 0,
    icon: 'bx-happy',
    percentage: '0.00',
    // profit: 'up'
    profit: 'equal'
}
    // , {
    //     title: 'PROFILE VIEWS',
    //     value: 86,
    //     icon: 'bx-user-circle',
    //     percentage: '0.00',
    //     profit: 'equal'
    // }
];

export { UpcomingSessions, PastSessions, statData };
